import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import GppGoodIcon from "@mui/icons-material/GppGood";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PsychologyIcon from "@mui/icons-material/Psychology";
import RouteIcon from "@mui/icons-material/Route";
import VerifiedIcon from "@mui/icons-material/Verified";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Typography,
  Stack,
} from "@mui/material";
import React from "react";
import { isMobile, isDesktop } from "react-device-detect";
import TaskIcon from "@mui/icons-material/Task";
import BoltIcon from "@mui/icons-material/Bolt";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ContactForm from "../components/ContactForm";
import FormularioBomberos from "../components/FormularioBomberos";
import BatteryChargingFullIcon from "@mui/icons-material/BatteryChargingFull";
import { info } from "../helpers/Info";
import "../styles/Habilitaciones.css";
import WhatsAppButton from "../components/WhatsAppButton";
import fondo from "../assets/cercaelectrica.jpg";
import fondo2 from "../assets/cercaelectrica.jpg";
import Reviews from "../components/Reviews";
import FormularioCercas from "../components/FormularioCercas";

const CercasElectricas = () => {
  /*   const ENDPOINT ="https://maps.googleapis.com/maps/api/place/details/json?place_id=ChIJHezobOCBn5URqKiywMM8Ht4&fields=reviews,rating&key=AIzaSyCM_BpfwovYkq2p3eWPB2mFlaZE-RpwEuM";*/

  //--------DIRECTO A API
  //  const ENDPOINT = "https://maps.googleapis.com/maps/api/place/details/json?place_id=ChIJHezobOCBn5URqKiywMM8Ht4&fields=rating,user_ratings_total,reviews&language=es&reviews_sort=newest&key=AIzaSyCM_BpfwovYkq2p3eWPB2mFlaZE-RpwEuM"

  //---------LAMBDA
  const ENDPOINT = process.env.REACT_APP_REVIEWS_ENDPOINT;

  const PLACE_ID = process.env.REACT_APP_PLACE_ID || "";
  return (
    <Box
      className="habilitaciones"
      sx={{ paddingTop: isMobile ? "70.4px" : "86px", bgcolor: "#fff" }}
    >
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          backgroundImage: !isMobile ? `url(${fondo})` : `url(${fondo2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: !isDesktop ? "column" : "row",
          alignItems: "center",
          color: "white",
          justifyContent: "center",
          textAlign: "center",
          maxWidth: "100%",
          height: !isDesktop ? "50vh" : "calc(100vh - 86px) ",
          maxHeight: "100vh",
          zIndex: 10,
        }}
      >
        <Stack direction="row" justifyContent="center">
          <Box
            sx={{
              zIndex: 10,
              textAlign: "center",
              width: !isDesktop ? "100%" : "40%",
              display: "flex",
              flexDirection: "column",
              justifyContent: isDesktop ? "space-between" : "center",
              /*  height: "100%", */
              maxWidth: "700px",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                maxWidth: isDesktop ? "94%" : isMobile ? "96%" : "90%",
                fontWeight: 700,
                textAlign: "center",
                lineHeight: isDesktop ? "3.3rem" : "",
                fontSize: isDesktop ? "3rem" : "1.5rem !important",
              }}
            >
              ¿Estas necesitando proteger tu propiedad? Instalamos tu cercado
              perimetral eléctrico
            </Typography>
          

            {!isDesktop && (
              <Stack
                sx={{ width: "96%", margin: "0 auto" }}
                direction="row"
                justifyContent="center"
              >
                <Button
                  variant="contained"
                  color="success"
                  sx={{
                    mt: 1,
                    fontWeight: "bold",
                    zIndex: 10,
                    width: "20rem",
                  }}
                  href={"/cercas-electricas#contacto"}
                >
                  quiero asesoramiento
                </Button>
              </Stack>
            )}
          </Box>
          {isDesktop && (
            <Box sx={{ width: "30%" }}>
              {" "}
              <FormularioCercas id="cercas" />{" "}
            </Box>
          )}
        </Stack>
        {/* Overlay negro */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1,
          }}
        />
      </Box>
      {!isDesktop && (
        <Box sx={{maxWidth:'96% !improtant' }}>
        <ContactForm
          placeholder="Información de utilidad: localidad, dirección,  y perimetro a cercar"
          id="cercas"
        />
        </Box>
      )}

      <Box py="2rem" sx={{ bgcolor: "#fafafa" }}>
        <Container>
          <Box my="2rem">
            <Typography variant="h5" textTransform="uppercase" gutterBottom>
              Cercado eléctrico perimetral
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
            >
              Un cerco eléctrico no es solo una barrera física, es una defensa
              activa y preventiva que protege tu hogar o empresa las 24 horas
              del día. Una instalación profesional asegura un sistema confiable,
              seguro y de bajo mantenimiento, que disuade intrusos y protege lo
              que más valorás.
            </Typography>
          </Box>
          <Stack alignItems="center">
            <Box my="2rem">
              <Typography variant="h5" textTransform="uppercase" gutterBottom>
                Características del servicio
              </Typography>
            </Box>
            <Stack alignItems="flex-start">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                {" "}
                <RadioButtonCheckedIcon sx={{ marginRight: "1.5rem" }} />
                <Typography
                  variant="body1"
                  sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
                >
                  Diseño, planificación e instalación del sistema.
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                {" "}
                <RadioButtonCheckedIcon sx={{ marginRight: "1.5rem" }} />
                <Typography
                  variant="body1"
                  sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
                >
                  {" "}
                  Instalación de centrales homologadas por DIGEFE y la normativa
                  vigente
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                {" "}
                <RadioButtonCheckedIcon sx={{ marginRight: "1.5rem" }} />
                <Typography
                  variant="body1"
                  sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
                >
                  {" "}
                  Cañerías, banco de bombas, tableros de automatismo, tanques y
                  bocas de incendio.{" "}
                </Typography>{" "}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                {" "}
                <RadioButtonCheckedIcon sx={{ marginRight: "1.5rem" }} />
                <Typography
                  variant="body1"
                  sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
                >
                  Reparación y mantenimiento de cercados existentes.
                </Typography>
              </Box>
            </Stack>
            <Typography
              variant="body1"
              sx={{
                fontSize: isMobile ? "1.2rem" : "1.43rem",
                marginTop: "1rem",
              }}
            >
              Con nuestro equipo técnico garantizamos un sistema seguro,
              eficiente y funcionando.
            </Typography>
          </Stack>
        </Container>
      </Box>

      {/* Beneficios */}
      {/*   <Box sx={{ bgcolor: "#f9f9f9" }}>
        <Container sx={{ py: 6 }}>
          <Typography
            variant="h4"
            mb={isMobile ? "2rem" : "4rem"}
            textTransform="uppercase"
            gutterBottom
          >
            Reseñas
          </Typography>
          <Grid container spacing={4}>
            {[
              {
                label: "Experiencia Especializada",
                icon: <VerifiedIcon fontSize="large" color="success" />,
              },
              {
                label: "Cumplimiento Normativo",
                icon: <GppGoodIcon color="success" fontSize="large" />,
              },
              {
                label: "Atención Personalizada",
                icon: <PsychologyIcon color="success" fontSize="large" />,
              },
            ].map((benefit, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <Box textAlign="center">
                  {benefit.icon}
                  <Typography
                    variant="h6"
                    textTransform="uppercase"
                    sx={{ mt: 1 }}
                  >
                    {benefit.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box> */}

     {/*  <Box>
        <Reviews endpoint={ENDPOINT} limit={6} placeIdForWriteLink={PLACE_ID} />
      </Box> */}
      {/* Formulario de Contacto */}
      <Divider />
      <WhatsAppButton
        id="btn-whatsapp-cercaselectricas"
        srOnly="Whatsapp cercaselectricas"
        message="Hola quiero información sobre cercas eléctricas"
      />
      {/* <ContactForm id="bomberos" /> */}
    </Box>
  );
};

export default CercasElectricas;
